import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { Observable, skip } from 'rxjs';
import { IError } from 'src/app/models/error.model';
import { ILoginRequest } from 'src/app/models/login.model';
import { IUser } from 'src/app/models/user.model';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';
import { LoginService } from 'src/app/services/login.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  faCircleXmark = faCircleXmark;
  loading = false;
  showPassword = false;

  // Modal de senha temporária
  showTemporaryPasswordModal = false;
  temporaryPasswordEmail = '';
  temporaryPassword = '';

  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  })

  warningPopup: Observable<IError>;
  errorMessage: string = '';

  constructor(private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private store: Store<{ warningPopup: IError }>,
    private authService: AuthService) {
    this.warningPopup = store.select('warningPopup');
    this.warningPopup.subscribe((error) => {
      this.errorMessage = error.message;
    });
  }

  ngOnInit(): void {
    // If already logged (token present), redirect straight to v2 main
    if (this.authService.isLogged()) {
      this.router.navigate(['main', 'v2']);
      return;
    }
    // Verifica se foi redirecionado por sessão expirada (apenas uma vez)
    const params = this.route.snapshot.queryParams;
    if (params['sessionExpired'] === 'true') {
      // Exibe a mensagem de sessão expirada
      setTimeout(() => {
        this.store.dispatch(setWarningText('Sua sessão expirou. Por favor, faça login novamente.'));
      }, 100);
      // Remove o query param da URL sem disparar navegação Angular
      window.history.replaceState({}, '', '/login');
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  navigateToLanding(): void {
    this.router.navigate(['/']);
  }

  onSubmitLogin(event: Event) {
    this.loading = true;

    if (this.loginForm.invalid) {
      this.loading = false;
      return;
    }
    
    this.loginService.login(this.loginForm.value.email?.trim().toLowerCase(), this.loginForm.value.password)
      .then((response: any) => {
        // Verifica se é desafio de senha temporária (NEW_PASSWORD_REQUIRED)
        if (response.challenge_name === 'NEW_PASSWORD_REQUIRED') {
          // Abre o modal de troca de senha temporária
          this.temporaryPasswordEmail = this.loginForm.value.email?.trim().toLowerCase();
          this.temporaryPassword = this.loginForm.value.password;
          this.showTemporaryPasswordModal = true;
          return;
        }

        // Se o login retornou um usuário válido (tem id ou jwt_token/access_token), redireciona
        if (response.jwt_token || response.access_token || response.id) {
          // Redireciona baseado na permissão do usuário
          this.redirectBasedOnPermission(response.permission);
        }
      })
      .catch((error) => {
        // Mostra mensagem de erro
        this.store.dispatch(setWarningText(error?.message || 'Email ou senha incorretos.'));
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onTemporaryPasswordModalClose(): void {
    this.showTemporaryPasswordModal = false;
    this.temporaryPasswordEmail = '';
    this.temporaryPassword = '';
  }

  onTemporaryPasswordSuccess(user: IUser): void {
    this.showTemporaryPasswordModal = false;
    // O modal já faz a navegação e salva os tokens
  }

  private redirectBasedOnPermission(permission: string | undefined) {
      this.router.navigate(['main', 'v2']);
  }

}
